import { render, staticRenderFns } from "./CSidebarNavItem.vue?vue&type=template&id=e114c8ee&scoped=true"
import script from "./CSidebarNavItem.vue?vue&type=script&lang=js"
export * from "./CSidebarNavItem.vue?vue&type=script&lang=js"
import style0 from "./CSidebarNavItem.vue?vue&type=style&index=0&id=e114c8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e114c8ee",
  null
  
)

export default component.exports